import { useState } from "react";
import useOptimizely from "@hooks/useOptimizely";
import useAnalytics from "@hooks/useAnalytics";
import useDeviceInfo from "@hooks/useDeviceInfo";
import useAuth from "@hooks/useAuth";
import getEvents from "@utils/get-events-from-definition";
import { analyticsEvents } from "@helpers/Analytics";

const useEvent = () => {
  const [userDidEngage, setUserDidEngage] = useState(false);
  const optimizely = useOptimizely();
  const { sendEvent } = useAnalytics();
  const { isLoggedIn } = useAuth();
  const { deviceType, analyticsId } = useDeviceInfo();
  const attributes = {
    DEVICE: deviceType,
    IS_LOGGED_IN: isLoggedIn,
  };
  return {
    dispatch: (action, label, data) => {
      const { ga: gaEventAction, op: optimizelyEventName } = getEvents(action);
      const eventTags = (action?.getTags && action.getTags(data)) || {};

      if (gaEventAction) {
        if (
          !userDidEngage &&
          gaEventAction !== analyticsEvents.pageView.action
        ) {
          optimizely.track(
            analyticsEvents.optimizelyEvent.userEngage.op,
            analyticsId,
            attributes,
            eventTags
          );
          setUserDidEngage(true);
        }
        sendEvent(gaEventAction, label);
      }

      if (optimizelyEventName) {
        try {
          optimizely.track(
            optimizelyEventName,
            analyticsId,
            attributes,
            eventTags
          );
        } catch (error) {
          console.log("Optimizely error", error);
        }
      }
    },
  };
};

export default useEvent;
